import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { DataDispatchChannelEnum } from '../../../shared/modules/data-dispatch/enums/data-dispatch-channel.enum';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';
import { OutboxTypeEnum } from '../enums/outbox-type.enum';

/**
 * Outbox DTO for records
 */
@CaslSubject(AppSubjectEnum.OUTBOX)
export class OutboxRecordDto extends BaseDto {
	/**
	 * Tenant ID
	 */
	tenantId!: number;

	/**
	 * Recipient user ID
	 */
	userId!: number;

	/**
	 * Outbox type
	 */
	type!: OutboxTypeEnum;

	/**
	 * Data dispatch channel
	 */
	channel!: DataDispatchChannelEnum;

	/**
	 * Status of the record
	 */
	status!: OutboxStatusEnum;

	/**
	 * Composite key describing the event and action that triggered the message
	 */
	key!: string;

	/**
	 * Notification context describing the specific event type
	 * @description Provides semantic meaning to the notification.
	 */
	context?: Record<string, any>;

	/**
	 * Source subject of the message
	 */
	subject!: AppSubjectEnum;

	/**
	 * Source subject ID of the message
	 */
	subjectId!: number;

	/**
	 * Unique token for the message
	 */
	dispatchToken!: string;

	/**
	 * Number of times the message has been retried
	 */
	retryCount!: number;

	/**
	 * Timestamp for the next retry attempt
	 */
	nextRetryAt?: Date;

	/**
	 * Timestamp for when the message was scheduled
	 */
	scheduledAt?: Date;

	/**
	 * The worker ID that reserved the message
	 */
	leasedBy?: string;

	/**
	 * Timestamp until when the message is reserved
	 */
	leasedUntil?: Date;

	/**
	 * Timestamp for when the message was dispatched
	 */
	dispatchedAt?: Date;

	/**
	 * Error message if the message failed to dispatch
	 */
	dispatchError?: string;
}
